import type { RatesSettings } from '@/settings/types';

export interface ProjectionRow {
  years: number;
  cycles: number;
  electricitySavingLkr: number;
  maintenanceSavingLkr: number;
  totalSavingLkr: number;
}

export function maintenanceCyclesForYears(years: number, cycleMonths: number): number {
  return Math.floor((years * 12) / cycleMonths);
}

export function projectSavings(
  monthlySavingLkr: number,
  totalFans: number,
  years: number,
  rates: RatesSettings,
): ProjectionRow {
  const cycles = maintenanceCyclesForYears(years, rates.maintenance.cycleMonths);
  const electricity = monthlySavingLkr * 12 * years;
  const maintenance =
    rates.maintenance.electricianLkr * totalFans +
    rates.maintenance.condenserLkr * totalFans * cycles;
  return {
    years,
    cycles,
    electricitySavingLkr: electricity,
    maintenanceSavingLkr: maintenance,
    totalSavingLkr: electricity + maintenance,
  };
}

export function projectionTable(
  monthlySavingLkr: number,
  totalFans: number,
  rates: RatesSettings,
  yearsList: number[] = [1, 2, 3],
): ProjectionRow[] {
  return yearsList.map((y) => projectSavings(monthlySavingLkr, totalFans, y, rates));
}
